import {AuthenticateStaffParams} from "./firestore.types";
import {auth, firestore} from "../../firebase";
import { setPersistence, signInWithEmailAndPassword, browserLocalPersistence, signOut } from "firebase/auth"
import {doc, getDoc} from "firebase/firestore";
import {staffFromJson} from "../../models/staff/staff";

export class AuthFirestore {

    async authenticateStaff(formData: AuthenticateStaffParams) {
        try {
            await setPersistence(auth, browserLocalPersistence)

            const userCredentials = await signInWithEmailAndPassword(auth, formData.email, formData.password);

            const user = await getDoc(doc(firestore,"staff", userCredentials.user.uid))

            console.log(userCredentials)

            return {kind: "ok", data: staffFromJson(user.data())}


        } catch (e) {
            console.log(e)
            return { kind: "bad-data" }
        }
    }

    async logout() {
        try {
            await signOut(auth)
            return {kind: "ok"}

        } catch (e) {
            return {kind: "bad-data"}

        }
    }
}
